<template>
  <!-- <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="name"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
  />-->

  <div v-if="!clickable" :class="$style.icon" :style="style" />
  <button v-else :class="$style.icon" :style="style" data-clickable />
</template>

<script>
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
// import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
// fontAwesomeIconLibrary.add(
//   require('@fortawesome/free-solid-svg-icons/faSync').definition,
//   require('@fortawesome/free-solid-svg-icons/faUser').definition
// )

export default {
  // components: {
  //   FontAwesomeIcon,
  // },
  inheritAttrs: false,
  props: {
    // source: {
    //   type: String,
    //   default: 'font-awesome',
    // },
    name: {
      type: String,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    // customIconClass() {
    //   return this.$style[camelCase('icon-custom-' + this.name)]
    // },
    backgroundImage() {
      return require(`@assets/images/icons/${this.name}.svg`)
    },
    style() {
      return {
        'background-image': `url(${this.backgroundImage})`,
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.icon {
  display: inline-flex;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
  // md is default size
  height: 24px;
  width: 24px;
  border: none;
  background-color: transparent;

  &.clickable {
    cursor: pointer;
  }
}
</style>
